import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import looppa from 'looppa';
import { cloneDeep } from 'lodash';
import { connect } from 'react-redux';
import reduxUtils from 'util/redux';
import MyMigrosSlider from 'components/mymigros-sliders/mymigros-slider';
import ActionTeaser from 'components/action-teaser';
import MigrosLoginButton from 'components/migros-login-button';
import { Trans } from 'translations';
import * as classnames from 'classnames';
import NavLink from 'react-router-dom/es/NavLink';

/**
 * @extends React.Component<IMyMigrosSlidersPlugin>
 */
class MyMigrosSliders extends PureComponent {
    static propTypes = {
        apiEndpoint: PropTypes.string,
        /** @type {IMyMigrosSlider[]} */
        sliders: PropTypes.array.isRequired,
        /** @type {ILink | null} */
        onboardingLink: PropTypes.object,

        // Redux
        isFetchingSliders: PropTypes.bool.isRequired,
        cumulus_connected: PropTypes.bool.isRequired,
        isAuthenticated: PropTypes.bool.isRequired,
        fetchedSliders: PropTypes.array,
        fetchSliders: PropTypes.func.isRequired,
        setSliders: PropTypes.func.isRequired,
        endpoints: PropTypes.object.isRequired,
    };

    state = {
        sliders: [],
    };

    componentDidMount() {
        const { isAuthenticated, cumulus_connected } = this.props;

        if (!isAuthenticated || !cumulus_connected) {
            return;
        }

        this.loadSliders();
    }

    componentDidUpdate(prevProps) {
        if (!this.props.fetchedSliders || this.props.fetchedSliders.length === 0) {
            this.props.setSliders(this.props.sliders);
        }

        if ((this.props.isAuthenticated && prevProps.isAuthenticated !== this.props.isAuthenticated)
            || (this.props.cumulus_connected && prevProps.cumulus_connected !== this.props.cumulus_connected)) {
            this.loadSliders();
        }
    }

    loadSliders = () => {
        const sliders = this.props.sliders.map(slider => {
            slider.products = [];
            return slider;
        });

        this.props.fetchSliders(cloneDeep(sliders), this.props.apiEndpoint);
    };

    renderOnboardingLink() {
        const { onboardingLink } = this.props;

        if (!onboardingLink) {
            return null;
        }

        return (
            <NavLink className="u-reset mymigros-sliders--onboarding-link" to={ onboardingLink.to }>
                <Trans path={ 'mymigros.onboardin_link_label' }/>
            </NavLink>
        );
    }

    render() {
        const { isAuthenticated, endpoints, isFetchingSliders, cumulus_connected, fetchedSliders } = this.props;


        if (!isAuthenticated) {
            return (
                <div className="mymigros-sliders">
                    <ActionTeaser
                        imagePath="img/login-teaser/img_rabbit.svg"
                        titleTranslationKey="mymigros.login_title"
                        descriptionTranslationKey="mymigros.login_body"
                    >
                        <MigrosLoginButton
                            inline={ true }
                            big={ true }
                            facet={ 'inline-block' }/>
                        { this.renderOnboardingLink() }
                    </ActionTeaser>
                </div>
            );
        }

        if (!cumulus_connected) {
            return (
                <ActionTeaser
                    imagePath="img/cumulus-teaser/img_happy_products.svg"
                    titleTranslationKey="mymigros.cumulus_connect_title"
                    descriptionTranslationKey="mymigros.cumulus_connect_body"
                >
                    <a className="btn btn__primary btn__teaser"
                        href={ endpoints.userConnectCumulus() }>
                        <Trans path={ 'mymigros.cumulus_connect_action' }/>
                    </a>
                </ActionTeaser>
            );
        }

        return (
            <div
                className={ classnames('mymigros-sliders', isFetchingSliders ? 'mymigros-sliders__is-fetching' : null) }>
                { looppa(fetchedSliders)((slider, idx) => (
                    <MyMigrosSlider
                        hasFetchedData={ !isFetchingSliders }
                        category={ slider.category }
                        key={ idx }
                        link={ slider.link }
                        kind={ slider.kind }
                        cumulus_connected={ cumulus_connected }
                        title_key={ slider.title_key }
                        header_link_label_key='mymigros.header_showall_link_label'
                        products={ slider.products }/>
                )) }
            </div>
        );
    }
}


export default connect(
    reduxUtils.mapStateToProps({
        isFetchingSliders: 'mymigros.isFetching',
        fetchedSliders: 'mymigros.sliders',
        hasCumulus: 'user.cumulus_connected',
        isAuthenticated: 'user.isAuthenticated',
        cumulus_connected: 'user.cumulus_connected',
        endpoints: 'router.endpoints',
    }),
    reduxUtils.mapDispatchToProps({
        fetchSliders: 'mymigros.fetchSliders',
        setSliders: 'mymigros.setSliders',
    }),
)(MyMigrosSliders);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/mymigros-sliders/index.js